import { Typography } from '@mui/material';

import { useWidgetSectionStyles } from './useWidgetSectionStyles';

interface WidgetSectionProps {
  children: React.ReactNode;
  title: string;
}

export const WidgetSection = ({ children, title }: WidgetSectionProps) => {
  const { classes } = useWidgetSectionStyles();

  return (
    <div className={classes.root}>
      <Typography color="textSecondary" variant="subtitle2">
        {title}
      </Typography>
      {children}
    </div>
  );
};
